import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

const getDate = params => formatGivenDate( ( params.data.date ), 'YYYY-MM-DD' );
function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const colDefs = [
    {
        field: 'id',
        headerName: 'ID',
        sortable: false,
        filter: true,
        width: 100
    },
    {
        field: 'date',
        headerName: 'Date',
        sortable: true,
        filter: true,
        width: 100,
        valueGetter: getDate
    },
    {
        field: 'time',
        headerName: 'Time',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'order',
        headerName: 'Order',
        sortable: true,
        filter: true,
        width: 100,
        cellRenderer: params => {

            if ( params.value ) {

                return ( <Link to={`/${params.data.unitName}/pools/pool-order-exchange-detail?ordernumber=${params.value.trim()}`}>{params.value}</Link> );

            }

            return ( <span>{' '}</span> );

        }
    },
    {
        field: 'prodOrder',
        headerName: 'Prod Order',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'family',
        headerName: 'Family',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'baseCode',
        headerName: 'Base Code',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'buildWeek',
        headerName: 'Build Week',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'message',
        headerName: 'Message',
        sortable: true,
        filter: true,
        width: 100
    }
];

const PoolOrderExchangesTable = props => (

    <section className="atp-search-result-panel pool-order-exchanges-panel ">
        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
            />
        </div>

    </section>
);

PoolOrderExchangesTable.propTypes = {
    results: PropTypes.array.isRequired,
    buildWeek: PropTypes.number
};
export default PoolOrderExchangesTable;
